<template>
  <div>
    <section class="BasicHeader BasicHeader--default ContentPageHeader">
      <div class="Header-topNav">
        <div class="Header-topNav-inner">
          <div style="text-align: center">
            <a class="BlueOceanLogo">
              美签智能填表
            </a>
          </div>
        </div>
      </div>
    </section>
    <div>
      <a-card title="基本信息">
        <CreateTable style="margin-bottom: 50px" ref="createTable" @emitBefore="emitBefore"
                     @emitFinally="emitFinally"></CreateTable>
      </a-card>
      <div class="footer">
        <a-row>
          <a-col :xs="{ span: 11, offset: 1 }" :sm="{ span: 11, offset: 1 }" :md="{ span: 11, offset: 1 }"
                 :lg="{ span: 11, offset: 1 }" :xl="{ span: 3, offset: 9 }" :xxl="{ span: 3, offset: 9 }">
            <a-button style="width: 100%;" @click="handleRetrieve">
              调出申请
            </a-button>
          </a-col>
          <a-col :xs="{ span: 11, offset: 1 }" :sm="{ span: 11, offset: 1 }" :md="{ span: 11, offset: 1 }"
                 :lg="{ span: 11, offset: 1 }" :xl="{ span: 3, offset: 1 }" :xxl="{ span: 3, offset: 1 }">
            <a-button type="primary" style="width: 100%;" @click="handleSubmit" :loading="submitLoading">
              下一步
            </a-button>
          </a-col>
        </a-row>
      </div>
      <a-back-top/>
    </div>
    <CreateSearchModal ref="createSearchModal" @ok="fillForm"></CreateSearchModal>
  </div>
</template>

<script>

import CreateTable from "@/components/usDs/CreateTable.vue";
import CreateSearchModal from "@/components/usDs/CreateSearchModal.vue";

export default {
  name: "CreateLink",
  components: {CreateSearchModal, CreateTable},
  data() {
    return {
      submitLoading: false,
      authority: ''
    }
  },
  mounted() {
    document.title = "美国DS160填表";
    if (this.$route.query.authority) {
      this.authority = this.$route.query.authority;
    }
    if (this.$route.query.auth) {
      this.authority = Buffer.from(this.$route.query.auth, 'base64').toString('utf-8');
    }
    if (!this.authority) {
      this.$message.error('连接不完整，请重新打开!');
      return false;
    }
    this.$refs.createTable.init({authority: this.authority});
  },
  methods: {
    handleSubmit() {
      this.$refs.createTable.handleSubmit('link');
    },
    handleRetrieve() {
      this.$refs.createSearchModal.show(this.authority);
    },
    fillForm(data) {
      this.$refs.createTable.init(data);
    },
    emitBefore() {
      this.submitLoading = true;
    },
    emitFinally() {
      this.submitLoading = false;
    }
  }
}
</script>


<style scoped>

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;

  padding: 10px 16px;
  text-align: right;
  background: white;
  border-top: 1px solid #e8e8e8;
  border-radius: 0 0 4px 4px;
}

.ant-menu-horizontal > .ant-menu-item > a:hover, .ant-menu-horizontal > .ant-menu-item > a {
  color: white;
}

.Header-topNav-inner nav {
  display: flex;
  height: 100%;
}

.ContentPageHeader {
  color: white;
}

.BasicHeader--default {
  background: #4a90e2;
}

.BasicHeader {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

.Header-topNav {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.1);
}

.Header-topNav-inner {
  height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-right: 15px;
  padding-left: 15px;
}

.BlueOceanLogo, .BlueOceanLogo:hover {
  display: flex;
  color: white;
  text-decoration: none;
  align-items: center;
  font-size: 20px;
  position: relative;
  top: -1px;
  font-weight: bold
}

</style>
